import _ from "lodash";
import {
  checkStatus,
  parseJSON,
  getApiUrl,
  getHeaderForAjax,
} from "./ServiceHelper";
import { getLoggedInUser, getAccessToken } from "./AuthenticationService";
// function getHeaderForAjax() {
//   return new Headers({
//     "Content-Type": "application/json",
//     token: getAccessToken(),
//     user: getLoggedInUser()._id,
//   });
// }

export async function getData(date, userID) {
  //{{server_url}}/users/{{user}}/daily_report/?start=1632256200000&participant=04200000273
  const user = await getLoggedInUser();
  let url =
    getApiUrl() +
    "/users/" +
    user._id +
    "/daily_report/?start=" +
    date +
    "&participant=" +
    userID;
  let method = "GET";
  return fetch(url, {
    method: method,
    headers: await getHeaderForAjax(),
  })
    .then(checkStatus)
    .then(parseJSON);
}



// WEBPACK FOOTER //
// ./src/services/DailySummaryService.js